var resources = [
    {
        link: "examples/BusinessDashboard",
        image: "./images/businessDashBoard.png",
        description: "비지니스 대시보드"
    },
    {
        link: "examples/financialKPIs",
        image: "./images/financialKPIs.png",
        description: "재무 KPI"
    },
    {
        link: "examples/AgingReport",
        image: "./images/agingReport.png",
        description: "에이징 보고서"
    },
    {
        link: "examples/incomeStatement",
        image: "./images/incomeStatement.png",
        description: "손익계산서"
    },
    {
        link: "examples/expensebudget",
        image: "http://grapecitycontentcdn.azureedge.net/en/pages/spreadsheets/plugin-conditionalformatting.png",
        description: "비용 예산"
    },
    {
        link: "examples/taxform",
        image: "./images/taxform.png",
        description: "1040 세금 양식"
    },
    {
        link: "examples/gradebookDashboard",
        image: "./images/gradebookDashBoard.png",
        description: "성적표 대시보드"
    },
    {
        link: "examples/cookbook",
        image: "./images/cookBook.png",
        description: "쿡북"
    },
    {
        link: "examples/CostOfGoodsSold",
        image: "./images/costOfGoodsSold.png",
        description: "판매 제품 원가"
    },
    {
        link: "examples/whatIfAnalysis",
        image: "./images/whatIfAnalysis.png",
        description: "가정 분석 템플릿"
    },
    {
        link: "examples/shapeOperationWorkflow",
        image: "./images/shapeOperationWorkflow.png",
        description: "Shape Operation Workflow"
    }
];
export default resources;


// WEBPACK FOOTER //
// ./client/components/resources.js